import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, RouterStateSnapshot, Routes } from '@angular/router';

import { isCb2PreviewNavigationAllowed } from './cb2-preview-navigation.policy';
import { Cb2PreviewStateService } from './cb2-preview-state.service';

/**
 * Cancels in-app navigations that would leave the CB2 preview page.
 * Route `redirectTo` entries do not run `canActivate`, so the same function
 * is also registered as `canActivateChild` on every parent.
 */
export const cb2PreviewNavigationGuard: CanActivateFn & CanActivateChildFn = (_route, state) =>
  allowCb2PreviewNavigation(state);

function allowCb2PreviewNavigation(state: RouterStateSnapshot): boolean {
  const preview = inject(Cb2PreviewStateService);
  if (!preview.isActive()) {
    return true;
  }
  const bootHref = preview.previewBootHref();
  if (!bootHref) {
    return false;
  }
  return isCb2PreviewNavigationAllowed(bootHref, state.url);
}

export function attachCb2PreviewNavigationGuard(routeList: Routes): void {
  for (const route of routeList) {
    if (!route.redirectTo && !route.canActivate?.includes(cb2PreviewNavigationGuard)) {
      route.canActivate = [cb2PreviewNavigationGuard, ...(route.canActivate ?? [])];
    }
    if (!route.canActivateChild?.includes(cb2PreviewNavigationGuard)) {
      route.canActivateChild = [cb2PreviewNavigationGuard, ...(route.canActivateChild ?? [])];
    }
    if (route.children) {
      attachCb2PreviewNavigationGuard(route.children);
    }
  }
}
